import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { DsIconComponent } from "./ds-icon.component";

@NgModule({
  declarations: [DsIconComponent],
  imports: [CommonModule, MatIconModule],
  exports: [DsIconComponent, MatIconModule],
})
export class DsIconModule {}
